import { CSSProperties, ReactNode } from "react";
import Button from "@weave-design/button";
import Modal from "@weave-design/modal";
import { WeaveDesignStylesheet } from "../sharedTypes";
import "./confirmDialog.css";

type ConfirmDialogProps = {
    title: string;
    isOpened: boolean;
    confirmButtonTitle?: string;
    deleteButtonClassName?: string;
    onCancel: () => void;
    onConfirm: () => void;
    windowStyles?: CSSProperties;
    children?: ReactNode;
};

export const ConfirmDialog = (props: ConfirmDialogProps) => {
    const modalStyles = (styles: WeaveDesignStylesheet) => ({
        ...styles,
        modal: {
            ...styles.modal,
            window: {
                ...styles.modal.window,
                height: undefined,
                width: "370px",
                ...props.windowStyles,
            },
        },
    });

    return (
        <Modal open={props.isOpened} title={props.title} onCloseClick={() => props.onCancel()} stylesheet={modalStyles}>
            <div className="confirmDialogContent">
                <div>{props.children}</div>

                <div className="confirmDialogButtonsContainer">
                    <Button
                        size="standard"
                        title={props.confirmButtonTitle || "OK"}
                        type="primary"
                        onClick={() => props.onConfirm()}
                        className={props.deleteButtonClassName || ""}
                    />

                    <Button
                        size="standard"
                        title="Cancel"
                        type="secondary"
                        onClick={() => {
                            props.onCancel();
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};
